import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { setUrlParam } from '@tencent/vft-common/util';
import env from '@tencent/vft-common/env';
import Storage from '@tencent/vft-common/Storage';
import { initUserState } from '@vip-activity/business';
import eventBus from '../util/eventBus';
import TicketService from '../service/ticket';
import Head from './Head/Head.vue';
import Introduce from './Introduce/Introduce.vue';
import Privilege1 from './Privilege1/Privilege.vue';
import Privilege2 from './Privilege2/Privilege.vue';
import Privilege3 from './Privilege3/Privilege.vue';
import Privilege4 from './Privilege4/Privilege.vue';
import StarComp from './StarComp/StarComp.vue';
import MovieComp from './MovieComp/MovieComp.vue';
import Footer from './Footer/Footer.vue';
import Nav from './Nav/Nav.vue';
import GetPop from './Pop/GetPop/GetPop.vue';
import SharePop from './Pop/SharePop/SharePop.vue';
import FriendStatusPop from './Pop/FriendStatusPop/FriendStatusPop.vue';
import LivePop from './Pop/LivePop/LivePop.vue';
var SAVE_KET = 'ysf_share_data_';
export default {
  data: function data() {
    return {
      showLivePop: false,
      currentPop: null,
      showPopArray: [],
      showReceivePop: false,
      diffUserList: [],
      shareInfo: null,
      showSharePop: false,
      showGetPop: false,
      isShowFixNav: false,
      selectNavIndex: 0
    };
  },
  components: {
    LivePop: LivePop,
    FriendStatusPop: FriendStatusPop,
    SharePop: SharePop,
    GetPop: GetPop,
    Head: Head,
    Introduce: Introduce,
    Privilege1: Privilege1,
    Privilege2: Privilege2,
    Privilege3: Privilege3,
    Privilege4: Privilege4,
    StarComp: StarComp,
    MovieComp: MovieComp,
    Footer: Footer,
    Nav: Nav
  },
  methods: _objectSpread(_objectSpread({
    // 弹框队列  popName 不传，表示关闭pop
    nextShowPop: function nextShowPop(popName) {
      if (popName) {
        this.showPopArray.push(popName);
      } else {
        this.currentPop = null;
      }

      if (this.currentPop) return;
      var topPop = this.showPopArray.splice(0, 1)[0];

      if (topPop) {
        this[topPop] = true;
        this.currentPop = topPop;
        eventBus.$emit('stopVideo');
      } else {
        eventBus.$emit('playVideo');
      }
    }
  }, mapActions({
    getNow: 'getNow',
    checkHasTicket: 'checkHasTicket',
    getBuyList: 'getBuyList',
    getOrderState: 'getOrderState',
    hasBookAct: 'hasBookAct',
    refreshLotteryInfo: 'refreshLotteryInfo'
  })), {}, {
    // 检查是否可以领取增票逻辑
    checkGetState: function checkGetState() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.oid || !_this.uid)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!_this.hasTicket) {
                  _context.next = 6;
                  break;
                }

                _this.$refs.getPop.clearKey();

                _this.toast('你已拥有线上观影票，无需重复领取哦');

                return _context.abrupt("return");

              case 6:
                _context.next = 8;
                return TicketService.getOrderState(_this.oid);

              case 8:
                state = _context.sent;

                if (!(state === 2)) {
                  _context.next = 13;
                  break;
                }

                _this.$refs.getPop.clearKey();

                _this.toast('哎呀来迟了，好友的票已经领完');

                return _context.abrupt("return");

              case 13:
                _this.nextShowPop('showGetPop');

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    saveShareData: function saveShareData(data) {
      Storage.setJSON(SAVE_KET, data);
      var url = setUrlParam('page', 'share', window.location.href);
      this.openUrl(url); // url = setUrlParam('hidestatusbar', '1', url)
      // url = setUrlParam('hidetitlebar', '1', url)
      // this.openUrl(`tenvideo2://?action=10&floatLevel=2&keepLoading=1&openurl=${encodeURIComponent(url)}`)
    },
    checkShareData: function checkShareData() {
      if (this.page !== 'share') {
        return;
      }

      var data = Storage.getJSON(SAVE_KET);

      if (data) {
        this.eventBus.$emit('launchShare', data);
      }
    },
    bindEvent: function bindEvent() {
      var _this2 = this;

      // 刷新购票信息
      eventBus.$on('refreshTicketInfo', function () {
        console.log('event:refreshTicketInfo:call');

        _this2.checkHasTicket();

        _this2.getBuyList(); // 预约首映直播


        if (_this2.$refs.anchor_point_0) {
          _this2.$refs.anchor_point_0.bookAct(false);
        } // 查询抽奖信息


        _this2.refreshLotteryInfo();
      }); // 弹出分享图

      eventBus.$on('launchShare', function (data) {
        console.log('event:launchShare:call', data);
        _this2.shareInfo = data;

        if (env.isApp && _this2.page === 'live') {
          _this2.saveShareData(data);

          return;
        }

        _this2.nextShowPop('showSharePop');
      }); // 领取列表弹框

      eventBus.$on('showReceive', function (data) {
        console.log('event:showReceive:call', data);
        _this2.diffUserList = data;

        _this2.nextShowPop('showReceivePop');
      });
      eventBus.$on('showLivePop', function () {
        _this2.nextShowPop('showLivePop');
      });
      this.$nextTick(function () {
        // 导航滚动监听事件
        var nav = _this2.$refs.nav;
        window.addEventListener('scroll', function () {
          if (!nav || !nav.$el) return;
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          var h = nav.$el.offsetTop - scrollTop;
          _this2.isShowFixNav = h < 0; // 滑动到指定楼层点亮
          // 计算4个导航分别距离顶部的距离

          var arr = [0, 1, 2, 3].map(function (v) {
            return _this2.$refs["anchor_point_".concat(v)].$el.offsetTop - 56;
          });

          for (var i = 0; i < arr.length; i += 1) {
            if (scrollTop >= arr[i] && (arr[i + 1] || Infinity) > scrollTop) {
              _this2.selectNavIndex = i;
            }
          }
        });
      });
    },
    initState: function initState() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.eventBus.$emit('getKillInfo');

                if (!_this3.loginService.isLogin) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return _this3.checkHasTicket();

              case 4:
                _this3.getBuyList(); // 查询预约信息


                _this3.hasBookAct(); // 查询抽奖信息


                _this3.refreshLotteryInfo();

              case 7:
                _this3.checkGetState();

                _this3.checkShareData();

                if (_this3.page === 'pay') {
                  _this3.eventBus.$emit('showPayPop');
                }

                if (_this3.page === 'role') {
                  _this3.$refs.anchor_point_0.selectActor();
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 导航切换
    selectNav: function selectNav(index) {
      var el = this.$refs["anchor_point_".concat(index)].$el;
      window.scroll({
        left: 0,
        top: el.offsetTop - 54
      });
    }
  }),
  created: function created() {
    this.bindEvent();
    this.getNow();
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return initUserState();

            case 2:
              _this4.initState();

              _this4.$report.ready();

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};